import { useCurrentUser } from '@mp';
import { MenuItem } from '@medely/web-components';
import React from 'react';
import { SettingsMenuItemsProps } from '../SettingsDropdown';
import { useNavigate } from 'react-router-dom';

export const IrpSettingsMenu = ({ handleClose }: SettingsMenuItemsProps) => {
  const { isDeactivated } = useCurrentUser();
  const navigate = useNavigate();
  return (
    <>
      {!isDeactivated && (
        <MenuItem
          onClick={() => {
            navigate('/profile');
            handleClose();
          }}
        >
          My Profile
        </MenuItem>
      )}
      <MenuItem
        onClick={() => {
          navigate('/settings');
          handleClose();
        }}
      >
        Settings
      </MenuItem>
    </>
  );
};
